/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createJobResponse } from '../models/api_createJobResponse';
import type { api_postgradCourseBulkIneligibleNotificationCountRequest } from '../models/api_postgradCourseBulkIneligibleNotificationCountRequest';
import type { api_postgradCourseBulkIneligibleNotificationCountResponse } from '../models/api_postgradCourseBulkIneligibleNotificationCountResponse';
import type { api_postgradCourseData } from '../models/api_postgradCourseData';
import type { api_updatePostgradCourseRequest } from '../models/api_updatePostgradCourseRequest';
import type { db_DropdownPostgradCourse } from '../models/db_DropdownPostgradCourse';
import type { db_ListPostgradAuditLogRow } from '../models/db_ListPostgradAuditLogRow';
import type { db_ListPostgradCoursesInstitutionsRow } from '../models/db_ListPostgradCoursesInstitutionsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PostgradCourses {
    /**
     * Get a list of postgrad courses
     * @param postgradOrganisationId Postgrad Organisation ID
     * @param academicYear Academic Year
     * @returns db_DropdownPostgradCourse OK
     * @throws ApiError
     */
    public static listPostgradCourses(
        postgradOrganisationId?: number,
        academicYear?: number,
    ): CancelablePromise<Array<db_DropdownPostgradCourse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/postgrad-courses',
            query: {
                'postgrad_organisation_id': postgradOrganisationId,
                'academic_year': academicYear,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Import postgrad course data
     * @param file CSV file to be imported
     * @returns api_createJobResponse Accepted
     * @throws ApiError
     */
    public static importPostgradCourseData(
        file: Blob,
    ): CancelablePromise<api_createJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/postgrad-courses',
            formData: {
                'file': file,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of Postgrad courses and institutions
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListPostgradCoursesInstitutionsRow OK
     * @throws ApiError
     */
    public static listPostgradCoursesInstitutions(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListPostgradCoursesInstitutionsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/postgrad-courses-institutions',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get the number of ineligible-course notification emails for selected postgrad courses
     * @param body Selected postgrad courses
     * @returns api_postgradCourseBulkIneligibleNotificationCountResponse OK
     * @throws ApiError
     */
    public static countPostgradCourseIneligibleNotificationRecipients(
        body: api_postgradCourseBulkIneligibleNotificationCountRequest,
    ): CancelablePromise<api_postgradCourseBulkIneligibleNotificationCountResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/postgrad-courses/ineligible-notification-count',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a Postgrad course
     * @param id Postgrad course ID
     * @returns api_postgradCourseData OK
     * @throws ApiError
     */
    public static getPostgradCourse(
        id: number,
    ): CancelablePromise<api_postgradCourseData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/postgrad-courses/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a Postgrad course
     * @param id Postgrad course ID
     * @param body Postgrad course details
     * @returns void
     * @throws ApiError
     */
    public static updatePostgradCourse(
        id: number,
        body: api_updatePostgradCourseRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/postgrad-courses/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get postgrad audit log
     * @param id Postgrad course ID
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListPostgradAuditLogRow OK
     * @throws ApiError
     */
    public static listPostgradAuditLog(
        id: number,
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListPostgradAuditLogRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/postgrad-courses/{id}/audit-log',
            path: {
                'id': id,
            },
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
